export const FETCHING_TRANSLATION_TABLES = 'FETCHING_TRANSLATION_TABLES';
export const FETCH_TRANSLATION_TABLES_SUCCESS = 'FETCH_TRANSLATION_TABLES_SUCCESS';
export const BACKUP_TRANSLATION_TABLES = 'BACKUP_TRANSLATION_TABLES';
export const RESTORE_TRANSLATION_TABLES = 'RESTORE_TRANSLATION_TABLES';
export const ADD_UNCONFIRMED_TRANSLATION_TABLE = 'ADD_UNCONFIRMED_TRANSLATION_TABLE';
export const DELETE_UNCONFIRMED_TRANSLATION_TABLE = 'DELETE_UNCONFIRMED_TRANSLATION_TABLE';



// WEBPACK FOOTER //
// ./src/redux/profileTranslationTables/ProfileTranslationTablesConstants.js